import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import EUserType from 'enums/userTypes';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import IWorkerEditRequestBody from 'services/httpClient/requests/worker/IWorkerEditRequestBody';
import IEditWorkerResponse from 'services/httpClient/responses/worker/IEditWorkerResponse';

import { workerActions } from '../index';
import { IWorkerEditRequestAction } from '../reducers/edit/request';

function* edit(action: PayloadAction<IWorkerEditRequestAction>) {
  try {
    const body: IWorkerEditRequestBody = {
      email: action.payload.data.email,
      locale: action.payload.data.locale,
      // team_id: action.payload.data.teamId,
      accountant:
        action.payload.data.userType === EUserType.Accountant || false,
      admin: action.payload.data.userType === EUserType.Admin || false,
      firstname: action.payload.data.firstName || undefined,
      lastname: action.payload.data.lastName || undefined,
      technician:
        action.payload.data.userType === EUserType.Technician || false,
      company_details: action.payload.data.company_details,
      user_management: action.payload.data.user_management,
      invoice_permission: action.payload.data.invoice_permission,
      all_interventions: action.payload.data.all_interventions,
    };

    const { data }: AxiosResponse<IEditWorkerResponse> = yield call(
      httpClient.put,
      `/rik/v1/workers/${action.payload.data.id}`,
      body,
    );

    yield put(workerActions.editSuccess(data));
    action.payload.functions.handleClose();
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(workerActions.editFailure());
  }
}

export default edit;
